import { useEffect, useState } from "react";

const LANG_STORAGE_KEY = "menchos-lang";
const DEFAULT_LANG = "en";

// Stores only the UI language code ("en" | "es") — no personal data.
export function useLanguage() {
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG);

  useEffect(() => {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return [lang, setLang];
}
